<template>
  <Card>
    <template slot="header">Change Password</template>
    <v-layout column>
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-text-field
          v-model="form.password1"
          :append-icon="showPassword ? 'visibility' : 'visibility_off'"
          :type="showPassword ? 'text' : 'password'"
          :rules="[validationRules.required, validationRules.passwordLength]"
          label="Password"
          browser-autocomplete="new-password"
          prepend-icon="fa-unlock-alt"
          @click:append="showPassword = !showPassword"
        />
        <v-text-field
          v-model="form.password2"
          :append-icon="showPassword ? 'visibility' : 'visibility_off'"
          :type="showPassword ? 'text' : 'password'"
          :rules="[validationRules.required, validationRules.passwordsMatch]"
          label="Enter Password Again"
          browser-autocomplete="new-password"
          prepend-icon="fa-unlock-alt"
          @click:append="showPassword = !showPassword"
        />
        <v-btn
          :disabled="!valid"
          @click="submit"
        >
          Submit
        </v-btn>
      </v-form>
    </v-layout>
  </Card>
</template>

<script>
// import vuex mapping
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      valid: false,
      showPassword: false,
      form: {
        password: null,
        password2: null
      }
    }
  },
  methods: {
    ...mapActions({
      updatePassword: 'person/updatePassword'
    }),
    submit () {
      if (this.$refs.form.validate()) {
        let data = {
          password: this.form.password1
        }
        this.updatePassword(data)
      }
    }
  }
}
</script>
